import React, { Component } from "react";
import { Row, Col, Panel, Alert } from 'react-bootstrap';
import { GenericSelectableTable } from "./GenericSelectableTable";

export class PointSelection extends Component {
    componentDidMount() {
        const { mandatoryPoints, onSelectAllMandatoryPoints } = this.props;
        onSelectAllMandatoryPoints(mandatoryPoints);
    }

    render() {
        const { pointType, mandatoryPoints, points } = this.props;
        const showWarning = pointType === 0 && mandatoryPoints.some(p => p.isStop);

        return (
            <div style={{ margin: "10px", overflowX: "clip" }}>
                <Row>
                    <Col>
                        {showWarning && (
                            <Alert bsStyle="warning">
                                <p style={{ padding: "10px" }}>
                                    <strong>Atenção:</strong> existem pontos obrigatórios que não estão associados a um ponto notável.<br></br>
                                    Esta condição impede a geração do mapa.<br></br>
                                    Resolva este problema através do módulo <a href='/datamanager/mappoints'>Gestor de Dados</a>.
                                </p>
                            </Alert>
                        )}
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Panel bsStyle="primary">
                            <Panel.Heading>
                                <h4 className="panel-title">Pontos Obrigatórios</h4>
                            </Panel.Heading>
                            <Panel.Body>
                                <GenericSelectableTable
                                    data={mandatoryPoints}
                                    isRowSelected={(row) => this.props.isRowSelected(row)}
                                    renderCell={(row) => {
                                        let label = row.isStop && 0 === pointType ? "(Paragem)" : "";
                                        let text = row.code !== undefined ? `${row.code} | ${row.name}` : row.name;
                                        return `${text} ${label}`;
                                    }}
                                />
                            </Panel.Body>
                        </Panel>
                    </Col>
                    <Col md={6}>
                        <Panel bsStyle="default">
                            <Panel.Heading>
                                <h4 className="panel-title">Selecionar Pontos</h4>
                            </Panel.Heading>
                            <Panel.Body>
                                <GenericSelectableTable
                                    data={points}
                                    onSearch={(filter) => this.props.onSearch(filter)}
                                    onRowClick={(row) => this.props.onRowClick(row)}
                                    isRowSelected={(row) => this.props.isRowSelected(row)}
                                    renderCell={(row) => {
                                        let label = row.isStop && 0 === pointType ? "(Paragem)" : "";
                                        let text = row.code !== undefined ? `${row.code} | ${row.name}` : row.name;
                                        return `${text} ${label}`;
                                    }}
                                    onSelectAll={() => { this.props.onSelectAll() }}
                                    sortableFields={[
                                        ...(points.some(p => p.isStop) ? [{ value: "code", label: "Código" }] : []),
                                        { value: "name", label: "Nome" },
                                    ]}
                                />
                            </Panel.Body>
                        </Panel>
                    </Col>
                </Row>
            </div>
        );
    }

}
